import React, { useState } from "react";
import { Modal } from "rsuite";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";
import { Equipament } from "../../../../interfaces/Equipament";
import api from "../../../../services/axios";

interface ModalDeleteComputerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  computer: Equipament | null;
  onDelete: () => void;
}

const ModalDeleteComputer: React.FC<ModalDeleteComputerProps> = ({
  open,
  setOpen,
  computer,
  onDelete,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    if (!computer) return;

    setLoading(true);
    try {
      await api.delete(`/Equipament/${computer.id}`);
      toast.success("Equipamento excluído com sucesso!");
      handleClose();
      onDelete();
    } catch (error: any) {
      console.error("Error deleting computer:", error);
      toast.error(
        error.response?.data?.message || "Erro ao excluir equipamento."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!computer) return null;

  return (
    <Modal open={open} size="sm" onClose={handleClose}>
      <Modal.Header>
        <Modal.Title>
          <b className="text-lg font-extrabold text-red-600 dark:text-red-400">Excluir Equipamento</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 dark:bg-red-900/40">
            <MdDeleteOutline
              className="h-8 w-8 text-red-600 dark:text-red-300"
              aria-hidden="true"
            />
          </div>
          <p className="text-gray-700 dark:text-gray-300">
            Tem certeza que deseja excluir o equipamento?
          </p>
          <p className="mt-2 font-bold text-navy-700 dark:text-white">
            {computer.model} ({computer.serieNumber})
          </p>
          <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">
            Esta ação não pode ser desfeita. Todo o histórico de uso será perdido.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-center gap-3">
          <button
            type="button"
            onClick={handleClose}
            className="flex items-center justify-center gap-1.5 rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 active:scale-[.98] dark:border-white/15 dark:text-gray-200 dark:hover:bg-navy-700"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleDelete}
            disabled={loading}
            className="flex items-center justify-center gap-1.5 rounded-xl bg-gradient-to-r from-red-500 to-red-400 px-5 py-2.5 text-sm font-bold text-white shadow-md shadow-red-500/25 transition-all hover:shadow-red-500/40 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? "Excluindo..." : "Excluir"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalDeleteComputer;
